<script lang="ts">
	import type { BundleData } from '@lib/types';
	import { getDiscountPercentage, priceFormatter } from '@lib/helpers/global';
	import { formatPriceForDisplay } from '@lib/utils';
	import bundlePlaceholderImg from '@lib/images/placeholders/bundle-banner.png?enhanced';
	import { twMerge } from 'tailwind-merge';

	export let bundle: BundleData;

	let className = '';

	export { className as class };
</script>

<div
	class={twMerge(
		'flex h-full flex-col overflow-hidden rounded-xl border bg-base-100 text-neutral',
		className
	)}
	aria-label={bundle.name}
>
	<div class="aspect-[720/300] bg-base-200">
		{#if bundle.image_url}
			<img
				class="aspect-[720/300] size-full object-cover object-center"
				src={bundle.image_url}
				alt={bundle.name}
			/>
		{:else}
			<enhanced:img
				class="aspect-[720/300] size-full object-cover object-center"
				src={bundlePlaceholderImg}
				alt={bundle.name}
			/>
		{/if}
	</div>
	<div class="flex h-full flex-col justify-between p-4">
		<div>
			{#if bundle.total_books}
				<p
					class="mb-2 grid h-6 w-full max-w-16 place-items-center rounded-full border border-primary bg-primary/20 text-xs font-medium text-primary"
				>
					{bundle.total_books} Buku
				</p>
			{/if}
			<p class="truncate font-medium" title={bundle.name}>{bundle.name}</p>
			{#if bundle.SubscriptionPlan}
				{@const sortedPriceSubscriptions = bundle.SubscriptionPlan?.sort(
					(a, b) => a.price - b.price
				)}
				{@const [lowestSubscriptionPrice] = sortedPriceSubscriptions}
				{#if lowestSubscriptionPrice}
					{@const { primary_price, price } = lowestSubscriptionPrice}
					<div class="mt-3 h-full space-y-1">
						<p class="text-xs font-medium text-gray-500">Mulai dari</p>
						{#if primary_price}
							<div class="flex items-center gap-2">
								<p class="text-sm font-medium text-error line-through">
									{priceFormatter.format(primary_price)}
								</p>
								<p class="rounded-md bg-success/10 px-1 py-0.5 text-xs font-medium text-success">
									-{getDiscountPercentage(primary_price, price)}%
								</p>
							</div>
						{/if}
						<p class="text-lg font-semibold text-secondary">
							{formatPriceForDisplay(price)}
						</p>
					</div>
				{/if}
			{/if}
		</div>
		<a class="btn btn-primary btn-block mt-5" href="/bundles/{bundle.id}">Lihat Detail</a>
	</div>
</div>
